import React from "react";
import PropTypes from "prop-types";
import Chip from '@material-ui/core/Chip';


const TagFilterBar = ({ tags, selectedTag, onTagSelect }) => (
  <div
    style={{
      gap: "24px",
      justifyContent: "center",
      alignItems: "center",
      margin: "32px 0 24px 0",
      flexWrap: "wrap",
      display: (tags && tags.length > 0) ? "flex" : "none",
    }}
  >
    {tags.map((tag) => (
      // <button
      //   key={tag.id}
      //   onClick={() => onTagSelect(selectedTag === tag.id ? null : tag.id)}
      //   style={{
      //     background: selectedTag === tag.id
      //       ? "color-mix(in srgb, var(--main-font-color) 10%, transparent)"
      //       : "transparent",
      //     color: "var(--main-font-color)",
      //     border: "none",
      //     fontWeight: selectedTag === tag.id ? "bold" : "normal",
      //     fontSize: "1.3rem",
      //     padding: "6px 18px",
      //     borderRadius: "6px",
      //     cursor: "pointer",
      //     transition: "all 0.2s",
      //     boxShadow: selectedTag === tag.id ? "0 2px 8px #0001" : "none",
      //   }}
      // >
      //   {tag.name}
      // </button>
      <Chip
        key={tag.id}
        label={tag.name}
        onClick={() => onTagSelect(selectedTag === tag.id ? null : tag.id)}
        style={{ backgroundColor: selectedTag === tag.id ? "var(--main-font-color)" : "transparent", color: selectedTag === tag.id ? "var(--main-color)" : "var(--main-font-color)", border: ".5px solid var(--main-font-color)" }}
      />
    ))}
  </div>
);

TagFilterBar.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedTag: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onTagSelect: PropTypes.func.isRequired,
};

export default TagFilterBar;